import Datepicker from 'vanillajs-datepicker/Datepicker';
import DateRangePicker from 'vanillajs-datepicker/DateRangePicker';
import cs from 'vanillajs-datepicker/locales/cs';

Object.assign(Datepicker.locales, cs);

export default class Rangepicker {
    static init(): void {
        const rangepickers = document.querySelectorAll('.rangepicker');

        rangepickers.forEach((rangepicker) => {
            const datepicker = new DateRangePicker(rangepicker, {
                autohide: true,
                language: 'cs',
                format: 'yyyy-mm-dd',
            });


            const labels = rangepicker.querySelectorAll('.rangepicker__label');
            labels.forEach((label) => {
                const input = label.querySelector('input');
                const dateTarget = label.querySelector('.rangepicker__date');

                if (!input || !dateTarget) {
                    return;
                }

                label.addEventListener('click', () => {
                    input?.dispatchEvent(new MouseEvent('click'));
                });

                input.addEventListener('changeDate', () => {
                    let date = input.value;
                    date = date.split('-').reverse().join('.');
                    dateTarget.innerHTML = date;
                });

                document.addEventListener('click', (e) => {
                    const target = e.target as HTMLElement;
                    if (!target.classList.contains('datepicker-cell')) {
                        return;
                    }

                    const inputTo = document.querySelector('#bookingDateTo') as HTMLInputElement;
                    const label = inputTo.closest('.rangepicker__label');
                    e.preventDefault();
                    label?.dispatchEvent(new MouseEvent('click'));
                });

            });
        });

    }
}
